import script from "./GameSummaryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GameSummaryModal.vue?vue&type=script&setup=true&lang=js"

import "../styles/_modals.scss?vue&type=style&index=0&lang=scss&external"
import "./GameSummaryModal.vue?vue&type=style&index=1&id=5732b84e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5732b84e"]])

export default __exports__